module.exports = __webpack_public_path__ + "img/pauli-x-root-10.8cba80bf.svg";